import { Icons } from '../components/icons/icons';
import React, { useState, useContext, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import { Pageable, Query, usePagination } from './use-pagination';
import { SearchContext } from '../state/search-sate';

type SearchProps = {
  path: string;
  name?: string;
};

type SearchHookResult<T> = {
  isSearching: boolean;
  searchData?: Pageable<T>;
  setSearchQuery: (query: Query) => void;
}

export const SearchField = (): JSX.Element => {
  const [search, setSearch] = useState<string>('');
  const [debounceSearch] = useDebounce(search, 400);
  const searchContext = useContext(SearchContext);

  useEffect(() => {
    searchContext.setSearch?.(debounceSearch);
  }, [debounceSearch]);

  const onReset = (): void => {
    setSearch('');
  };

  return <div className="page-search">
    <Icons.Search />
    <input type="text" className="form-control" placeholder="Search" value={search} onChange={(event): void => setSearch(event.target.value)} />
    {search && (
      <span className="search-clear pointer" onClick={onReset}>
        <Icons.Close />
      </span>
    )}
  </div>;
};

export function useSearch<T>(props: SearchProps): SearchHookResult<T> {
  const { search } = useContext(SearchContext);
  const [query, setQuery] = useState<Query>({});
  const searchData = usePagination<Pageable<T>>(props.path, { ...query, query: search }, { enabled: Boolean(search) });

  return {
    setSearchQuery: setQuery,
    searchData: searchData.data,
    isSearching: Boolean(search) && Boolean(searchData.data)
  };
}
